import React from "react";
import { Box } from "@mui/material";
import { useWindowSize } from "@uidotdev/usehooks";
import { getGuideAccent } from "../../utils/guideAccent";

// Template325 (Edimburgo): Cómo moverse
const Template325 = ({
	backgroundColor,
	textColor,
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
}) => {
	const size = useWindowSize();
	const isSmallScreen = size.width <= 600;

	const headerText = page?.texts?.[0]?.content;
	const logoImage = page.canvasImages?.find(
		(img) => img.id === "logo",
	)?.imageUrl;
	const introText = page?.texts?.[1]?.content;
	const sections = Array.isArray(page?.sections) ? page.sections : [];
	const footerStickerId = page?.footerSticker?.stickerCanvasId;
	const footerBubble = page?.footerSticker?.bubble;
	const footerStickerSrc = page.canvasImages?.find(
		(img) => img?.id === footerStickerId,
	)?.imageUrl;

	const actualHeaderColor = headerBackgroundColor || "#de5624";
	const accent = getGuideAccent(actualHeaderColor);
	const contentColor = textColor || "#444";

	const h3 = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: 14,
		fontWeight: 700,
		textTransform: "uppercase",
		marginBottom: "6px",
		marginTop: 0,
		color: accent.accent,
	};

	const p = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: 13,
		color: contentColor,
		margin: 0,
		lineHeight: 1.4,
		"& strong": { fontWeight: 700, color: contentColor },
	};

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				minHeight: "100%",
				height: "auto",
				width: "100%",
				backgroundColor: backgroundColor || "#f7f7f7",
				color: contentColor,
				fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				"& *:not([data-template-header])": {
					fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				},
			}}
		>
			{headerText && (
				<Box
					data-block-id="header"
					data-template-header
					sx={{
						backgroundColor: actualHeaderColor,
						color: headerTextColor || "#fff",
						textAlign: "center",
						padding: "15px 0",
						fontSize: "14px",
						fontWeight: 600,
						flexShrink: 0,
						position: "sticky",
						top: 0,
						zIndex: 99999,
					}}
				>
					{headerText}
					{logoImage && !isSmallScreen && (
						<Box
							component="img"
							src={logoImage}
							alt="logo"
							sx={{
								width: isSmallScreen ? 66 : 80,
								position: "absolute",
								right: 2,
								top: 18,
								zIndex: 999999,
							}}
						/>
					)}
				</Box>
			)}

			{introText && (
				<Box data-block-id="text-1" sx={{ padding: "12px 16px 6px" }}>
					<Box component="p" sx={p}>
						{introText}
					</Box>
				</Box>
			)}

			<Box
				sx={{
					padding: "0 16px 16px",
					display: "flex",
					flexDirection: "column",
					gap: "10px",
				}}
			>
				{sections.map((section, idx) => {
					const isYellow = section.layout === "yellow";
					const isHighlight = section.layout === "highlight";

					return (
						<Box
							key={idx}
							data-block-id={`text-${idx + 2}`}
							sx={{
								backgroundColor: isYellow
									? "#fff8db"
									: isHighlight
										? "#f7fafc"
										: accent.boxBg,
								border: isYellow
									? "2px solid #f5c400"
									: isHighlight
										? `2px solid ${accent.boxBorder}`
										: "none",
								borderRadius: "12px",
								padding: "10px 12px",
							}}
						>
							{section.title && (
								<Box component="h3" sx={h3}>
									{section.title}
								</Box>
							)}
							{section.body && (
								<Box
									component="p"
									sx={p}
									dangerouslySetInnerHTML={{ __html: section.body }}
								/>
							)}
						</Box>
					);
				})}
			</Box>

			{footerStickerSrc && (
				<Box
					sx={{
						position: "relative",
						height: isSmallScreen ? 88 : 96,
						overflow: "visible",
						flexShrink: 0,
						margin: "0 16px 12px",
					}}
				>
					<img
						src={footerStickerSrc}
						alt=""
						style={{
							width: 95,
							position: "absolute",
							right: -10,
							bottom: 0,
							zIndex: 5,
						}}
					/>
					{footerBubble && (
						<Box
							sx={{
								position: "absolute",
								right: 78,
								top: isSmallScreen ? 0 : 12,
								backgroundColor: "#fff8db",
								border: "2px solid #f5c400",
								borderRadius: "16px 16px 0px 16px",
								padding: "8px 10px",
								fontSize: 11,
								fontFamily: `${fontFamily || "'Poppins', sans-serif"}`,
								color: contentColor,
								boxShadow: "2px 2px 4px rgba(0,0,0,0.15)",
								width: isSmallScreen ? 170 : 200,
								zIndex: 6,
								lineHeight: 1.35,
							}}
						>
							{footerBubble}
						</Box>
					)}
				</Box>
			)}
		</Box>
	);
};

Template325.thumbnail = "/images/template-1.png";

export default Template325;
